import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { EMPTY, Observable, switchMap, take } from "rxjs";
import { AuthService } from "../services/auth.service";

// Se impostato a true, l'interceptor di autenticazione ignorerà la richiesta
export const BYPASS_AUTH = new HttpContextToken(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private authService = inject(AuthService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log("AuthInterceptor init" , req.url);

        // Se la chiamata è marcata con BYPASS_AUTH a true, vado oltre
        if (req.context.get(BYPASS_AUTH)) {
            return next.handle(req);
        }

        return this.authService.getToken().pipe(
            take(1), // Prende il token (esegue eventuale refresh) e prosegue
            switchMap(token => {
                if (!token) {
                    console.log("logout")
                    this.authService.logout();
                    return next.handle(req);
                }
                
                // Token valido, lo aggiungo
                const authReq = req.clone({ 
                    setHeaders: { 
                        Authorization: `Bearer ${token}` 
                    } 
                });
            
                return next.handle(authReq);
            })
        );
    };
}
